import Model from './model.js'
import Deal from './deal.js'
import { reactive, computed } from 'vue'

export default class Upload extends Model {
	static _routeKey = 'upload'
	static _attributes = {
		folder_id: null,
		name: '',
	}

	_logIcon() {
		return 'IconNoteDraftCircle'
	}

	tailIgnore = ['size', 'uuid', 'url', 'extention', 'file_name', 'folder_type', 'state']

	tail = {
		name: () => ['file name', this.name],
		folder_id: () => ['folder', this.vue.$help.capitalizeFirstLetter(this.folder_id)],
		downloaded_at: () => ['downloaded at', this.downloaded_at != null ? this.vue.$help.formatDateTime(this.downloaded_at) : null],
		createdDescription: () => '' + this.truncateFileName(this) + ' was uploaded',
		removedDescription: () => '' + this.truncateFileName(this) + ' was deleted',
		updatedDescription: {
			folder_id: () => '' + this.truncateFileName(this) + ' moved to ' + this.vue.$help.capitalizeFirstLetter(this.folder_id),
			name: () => 'File name changed to ' + this.truncateFileName(this),
		},
		logType: (type) => {
			return { created: 'uploaded', updated: 'renamed', removed: 'deleted' }[type]
		},
		noLineKeys: () => ['folder'],
	}

	me() {
		return 'file'
	}

	state = {}

	_constructor() {
		let state = reactive({
			uploading: false,
			error: null,
			upload: null,
		})

		this.state = state

		if (parseInt(this.belongs_type) == 103) {
			console.log(this)
			this.belongs = new Deal(this.belongs)
		}
	}

	truncateFileName(upload) {
		if (upload.name == undefined) {
			return 'undefined'
		}

		let split = String(upload.name).split('.')
		let n = upload.name.replace('.' + upload.extention, '')

		if (split.length == 0 || n.length <= 20) {
			return upload.name
		}

		return n.slice(0, 19) + '~.' + upload.extention
	}
	// constructor() {
	//     super()

	//     let state = reactive({
	//         uploading: false,
	//         error: null,
	//         upload: null,
	//     })

	//     this.state = state
	// }

	upload(file, $vue, options = {}) {
		let formData = new FormData()
		formData.append('file', file)

		for (let key in options) {
			formData.append(key, options[key])
		}

		this.state.uploading = true

		$vue.$axios
			.post('/upload', formData, {
				headers: { 'Content-Type': 'multipart/form-data' },
			})
			.then((res) => {
				this.state.uploading = false
				this.state.upload = res
				return this.state
			})
			.catch((e) => {
				this.state.uploading = false
				this.state.error = e.data.errors

				console.log(this.state.error)
				return this.state
			})

		return this.state
	}
}
